var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-combobox", {
        staticClass: "chiped-input",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          "menu-props": { contentClass: "grv-menu" },
          rules: _vm.rules,
          value: _vm.value,
          clearable: "",
          items: _vm.items,
          loading: _vm.loading,
          "item-text": "email",
          "item-value": "id",
          "search-input": _vm.search,
          name: _vm.param.name,
          multiple: _vm.multiple,
          readonly: _vm.readonly,
          "auto-select-first": "",
          dense: _vm.dense,
          "no-filter": "",
          "hide-no-data": "",
          chips: "",
          "small-chips": _vm.dense,
          "deletable-chips": !_vm.readonly,
          placeholder: "Rechercher un contact"
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          blur: function($event) {
            return _vm.onblur()
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          },
          change: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        nativeOn: {
          paste: function($event) {
            return _vm.onPaste($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ccf5dd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccf5dd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/email.vue
// module id = null
// module chunks = 